import type { BinogQuestion } from "@binogi-livequiz/shared";

export function decodeQuestionsParam(value: string): BinogQuestion[] {
  const b64 = value.replace(/-/g, "+").replace(/_/g, "/");
  const padLength = b64.length % 4 === 0 ? 0 : 4 - (b64.length % 4);
  const padded = b64 + "=".repeat(padLength);
  const binary = atob(padded);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  const json = new TextDecoder().decode(bytes);
  const parsed: unknown = JSON.parse(json);
  if (!Array.isArray(parsed)) {
    throw new Error("questions param must be a JSON array");
  }
  return parsed as BinogQuestion[];
}
